import { COMPANIES_BRANDING } from '@shared/constants/branding';

const DEFAULT_PRODUCT_NAME = COMPANIES_BRANDING.default.title;

export const formatPageTitle = (pageName?: string, companyName?: string): string => {
  const suffix = (companyName?.trim() || DEFAULT_PRODUCT_NAME).trim();
  const page = pageName?.trim();

  if (page) {
    return `${page} | ${suffix}`;
  }

  return suffix;
};
